import { Avatar, Text } from "@pentabd/ui";

import { CustomFileInfoCard } from "./CustomFileInfoCard";

import { useUser } from "@hooks/useUser";

import { formatDateTime } from "@utils/formatDateTime";

import { UploadFileType } from "@type/HRM/upload-file";

interface CommentType {
  comment: string;
  name: string;
  createdAt: string;
  imageURL?: string;
  email?: string;
  document?: UploadFileType;
}

export const Comment = ({
  name,
  createdAt,
  comment,
  imageURL,
  email,
  document,
}: CommentType) => {
  const { user } = useUser();
  const { email: userEmail } = user || {};

  return (
    <>
      {comment.length && (
        <div
          className={`d-flex gap-4 ${
            userEmail === email && "flex-row-reverse"
          } w-100`}
        >
          <Avatar size="xs" name={name} imageURL={imageURL} />
          <div className="w-50 d-flex flex-column gap-2">
            <div
              className={`w-100 d-flex flex-wrap gap-4 justify-content-between align-items-center ${
                userEmail === email && "flex-row-reverse"
              }`}
            >
              <Text size="sm" color="subtitle1">
                {name}
              </Text>
            </div>
            <div className="px-10 py-6 bg-light d-flex flex-column gap-5 rounded-8 border">
              <Text color="title">{comment}</Text>
              <Text color="subtitle3" size="xs" className="align-self-end">
                {formatDateTime(createdAt)}
              </Text>
            </div>
            {document && (
              <div className="mt-5 d-flex flex-column gap-8">
                {document.map((item: any) => (
                  <CustomFileInfoCard
                    key={item?.id}
                    id={item?.id}
                    fileName={item?.name}
                    fileType={item?.mimeType}
                    documentId={item?.documentId}
                    fileId={item?.fileId}
                    disabled={true}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
